/* eslint-disable @typescript-eslint/naming-convention */
export enum ContentType {
  LiveTournament = 'live_tournament',
  WebsiteLanguages = 'website_languages',
  Website = 'website',
  VideoPanel = 'video_panel',
  Tournament = 'tournament',
  Top = 'top',
  TilesGrid = 'tiles_grid',
  Terms = 'terms',
  Tabs = 'tabs',
  StickyFooter = 'sticky_footer',
  SiteHeader = 'site_header',
  SiteFooter = 'site_footer',
  SideTwitter = 'side_twitter',
  SideRelatedContent = 'side_related_content',
  SideCTA = 'side_cta',
  Side = 'side',
  SEO = 'seo',
  Redirect = 'redirect',
  PromotionBanner = 'promotion_banner',
  Podcast = 'podcast',
  PaymentVendors = 'payment_vendors',
  Panel = 'panel',
  Page = 'page',
  Meta = 'meta',
  Menu = 'menu',
  MediaGrid = 'media_grid',
  Main = 'main',
  Language = 'language',
  LinkedImageList = 'linked_image_list',
  LanguageBanner = 'language_banner',
  IconsGrid = 'icons_grid',
  Highlight = 'highlight',
  Grid = 'grid',
  Glossary = 'glossary',
  GeoRedirect = 'geo_redirect',
  Form = 'form',
  FAQ = 'faq',
  EventSchedule = 'event_schedule',
  DetailsGrid = 'details_grid',
  ContentCard = 'content_card',
  ContentArea = 'content_area',
  CategoryHighlight = 'category_highlight',
  CasinoSEOSection = 'casino_seo_section',
  CasinoGameInfo = 'casino_game_info',
  CTAGrid = 'cta_grid',
  CrmTargeting = 'crm_targeting',
  BrandLogo = 'brand_logo',
  Box = 'box',
  BonusGrid = 'bonus_grid',
  AppFooterContent = 'app_footer_content',
  Accordion = 'accordion'
}

export interface Reference {
  uid: string;
  _content_type_uid: ContentType;
}
